














import { Component, Vue } from 'vue-property-decorator';
import Navbar from '@/components/Navbar.vue';
import Services from '@/components/Services.vue';
import Carousel from '@/components/Carousel.vue';
import About from '@/components/About.vue';
import ContactForm from '@/components/ContactForm.vue';

const Contact = () => ({
  // eslint-disable-next-line
  component: import('@/components/Contact.vue') as any,
  delay: 500,
});

@Component({
  components: {
    ContactForm,
    Contact,
    About,
    Carousel,
    Services,
    Navbar,
  },
})
export default class App extends Vue {
  public scrolled = false;

  mounted() {
    window.addEventListener('scroll', () => {
      this.scrolled = window.scrollY >= 60;
    });
  }

  // eslint-disable-next-line class-methods-use-this
  toTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
